import React from 'react';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import cn from 'classnames';

type ChartLegendProps = {
  id: string;
  label: string;
  iconColor?: string;
  focused: boolean;
  onClick(id: string): void;
  hasTransparentBorder?: boolean;
  isDashed?: boolean;
};

/**
 * Button to be used in progress chart legend to filter data
 */
export function ChartLegendButton({
  id,
  label,
  iconColor,
  focused,
  onClick,
  hasTransparentBorder,
  isDashed,
}: ChartLegendProps) {
  return (
    <Button
      variant="outline"
      role="button"
      behavior={{
        type: 'onClick',
        onClick: () => onClick(id),
      }}
      size="small"
      className="mr-2"
      innerClassName={[
        'rounded text-gray-900 border-1 font-bold whitespace-nowrap transition inline-block !ring-0',
        focused ? 'bg-gray-100' : 'bg-transparent',
        hasTransparentBorder ? 'border-transparent' : 'border-gray-200',
      ]}
    >
      <div className="flex items-center gap-2">
        {iconColor !== undefined && (
          <div className="w-[10px] h-[10px] flex items-center">
            {isDashed ? (
              <div
                className={cn(
                  'w-full h-[2px] border-t-2 border-dashed',
                  iconColor?.replace('bg-', 'border-'),
                )}
              />
            ) : (
              <div className={cn('w-full h-full rounded-sm', iconColor)} />
            )}
          </div>
        )}
        <span className="color-gray/900 capitalize">{label}</span>
      </div>
    </Button>
  );
}
